import PropTypes from 'prop-types';
import React from 'react';

import { preventOrphans } from '../../tools/textTools';
import ContentContainer from '../Common/ContentContainer';
import ContentfulImage from '../Common/ContentfulImage';
import { ArrowLink } from '../Common/Links';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import SmartLink from '../Common/SmartLink';
import * as styles from './HalfAndHalfContent.module.css';

/*const backupSimpleCard = () => (<RichTextConverter copy={section.copy?.body} />
<ArrowLink label={section.ctaLabel} url={section.ctaUrl} />
<GatsbyImage className={styles.copyImage} alt={section.logo.title} image={section.logo?.gatsbyImageData} />)*/

const TestimonialArea = ({ testimonial }) => {
  return (
    <div>
      <div className={styles.quote}>
        <p>{testimonial.quote?.quote}</p>
      </div>
      <div className={styles.attribution}>
        <ContentfulImage
          className={styles.attributionImage}
          imageFragment={testimonial.attributionImage}
          gatsbyImageData={testimonial.attributionImage?.profile}
        />
        <div className={styles.person}>
          <span>{testimonial.attribution}</span>
          <span className={styles.company}>{testimonial.company}</span>
        </div>
      </div>
      {testimonial.heading && (
        <div className={styles.testimonialHeading}>
          <p>{testimonial.heading}</p>
        </div>
      )}
    </div>
  );
};

const HalfAndHalfContent = ({ section, extended = false }) => {
  // Add non-breaking space between last two words and replace hyphens with non-breaking versions
  const heading = preventOrphans(section.heading);

  let content;
  if (section.contentArea?.__typename === 'ContentfulTestimonial') {
    content = <TestimonialArea testimonial={section.contentArea} />;
  } else if (section.contentArea?.__typename === 'ContentfulSimpleCard') {
    content = (
      <RichTextConverter key={section.contentful_id} copy={section.contentArea.body} className={styles.paragraph} />
    );
  } else if (section.contentArea?.__typename === 'ContentfulGroupedContent') {
    const list = Object.values(section.contentArea.content);
    content = (
      <div className={styles.iconList}>
        {list?.map((li, i) => (
          <div key={`container-${i}`}>
            <img src={li.image?.file?.url} alt={li.image?.title} />
            <RichTextConverter copy={li.body} key={i} />
          </div>
        ))}
      </div>
    );
  }
  let overlay = section.backgroundOverlayColor?.replace(' ', '');
  const bgColor = styles[`bg${overlay}`];
  return (
    <ContentContainer
      className={[styles.container, extended ? styles.extended : ''].join(' ')}
      style={{
        '--backgroundImg': `url(${section.backgroundImage?.file?.url})`,
      }}
    >
      <div className={styles.leftSide}>
        <div className={[styles.gradientBackground, bgColor].join(' ')} />
        <div className={styles.copyContainer}>
          <div className={styles.copy}>
            <h3>{heading}</h3>
            {content && <>{content}</>}
          </div>
          {section.callToAction && (
            <div className={styles.cta}>
              <SmartLink to={section.callToAction.url} isExternal={section.callToAction.newWindow}>
                <ContentfulImage imageFragment={section.callToAction.image} />
              </SmartLink>
              <div>
                <ArrowLink
                  isExternal={section.callToAction.newWindow}
                  inheritColor={true}
                  label={section.callToAction.ctaLabel}
                  url={section.callToAction.url}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </ContentContainer>
  );
};

HalfAndHalfContent.propTypes = {
  section: PropTypes.object.isRequired,
};

export default HalfAndHalfContent;
